import api from '__jsVueApi';

export default {
	async loadSuccessCreterisa({ state, commit }) {
		commit('main/setLoad', true, { root: true });
		await axios
			.get(api.successCriteria.get)
			.then(response => {
				let data = {};
				for (const key in response.data) {
					if (response.data.hasOwnProperty(key)) {
						const field = response.data[key];
						data[key] = field;
					}
				}
				commit('setFields', data);
			})
			.catch(err => {
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},

	async updateSuccessCreteria({ state, commit, rootState }) {
		commit('main/setLoad', true, { root: true });
		axios.defaults.headers[rootState.main.header.name] = rootState.main.header.value;
		axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
		commit('clearErrors');
		// let fields = {};
		// for (const key in state.fields) {
		// 	if (state.fields.hasOwnProperty(key)) {
		// 		const element = state.fields[key];
		// 		if (element !== null && element !== '') {
		// 			fields[key] = element;
		// 		}
		// 	}
		// }
		await axios
			.patch(api.successCriteria.put, state.fields)
			.then(() => {
				const urlString = window.location.href;
				const url = new URL(urlString);
				const nextUrl = url.searchParams.get('next');
				if (nextUrl) {
					window.location.href = nextUrl;
				}
			})
			.catch(err => {
				let data = {};
				for (const key in err.response.data) {
					if (err.response.data.hasOwnProperty(key)) {
						const field = err.response.data[key];
						if (field.length) {
							data[key] = field[0];
						}
					}
					commit('setErrors', data);
				}
			});
		commit('main/setLoad', false, { root: true });
	}

};
